module.exports = __webpack_public_path__ + "static/media/2.21bba6a8.JPG";